import { render, staticRenderFns } from "./WeightlessnessViz.vue?vue&type=template&id=18456bb8&scoped=true"
import script from "./WeightlessnessViz.vue?vue&type=script&lang=js"
export * from "./WeightlessnessViz.vue?vue&type=script&lang=js"
import style0 from "./WeightlessnessViz.vue?vue&type=style&index=0&id=18456bb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18456bb8",
  null
  
)

export default component.exports